import React, { useState } from 'react';
import { inputCurrencyConvertion } from "../../../../../utils/helper";

const AnswerMultipleChoicesTable = ({ answerId, answer, priceEditable = false, onChangeMultipleChoicesPrice }) => {
    const styles = {
        evaluationRD: {
            fontSize: '13px'
        }
    }

    const [localPrices, setLocalPrices] = useState(
        () => answer.reduce((acc, opt) => {
            acc[opt.id] = opt.price ?? "";
            return acc;
        }, {})
    )

    const handleChange = (optionId, value) => {
        setLocalPrices(prev => ({
            ...prev,
            [optionId]: inputCurrencyConvertion(value)
        }));
    }

    const handleBlur = (optionId) => {
        setLocalPrices(prev => ({
            ...prev,
            [optionId]: localPrices[optionId]
        }));
        onChangeMultipleChoicesPrice(answerId, optionId, localPrices[optionId]);
    }

    return (
        <table className="visit-details-evaluation table-images">
            <thead className="visit-details-evaluation-table-thead">
                <tr>
                    <td style={{ maxWidth: '55px' }}><div>Resposta</div></td>
                    <td><div>Preço</div></td>
                </tr>
            </thead>

            <tbody>
                {answer.map((options, i) => (
                    <tr key={options.id} style={styles.evaluationRD}>
                        <td className="td-brand-name"><div>{options.answer}</div></td>
                        <td>
                            R$
                            {priceEditable ? (
                                <input
                                    name='answer_price_value'
                                    type="text"
                                    value={localPrices[options.id] ?? ""}
                                    style={{ width: "80px" }}
                                    onChange={({ target }) => handleChange(options.id, target.value)}
                                    onBlur={() => handleBlur(options.id)}
                                />
                            ) : (
                                options.price
                            )}
                        </td>
                    </tr>
                ))}
            </tbody>
        </table>
    );
};

export default AnswerMultipleChoicesTable;